module.exports = __webpack_public_path__ + "img/icon1_a.bd1c01e0.png";